module.exports = __webpack_public_path__ + "static/media/right.567a0871.png";